<template>
  <div>

    <a-form :form="form" @submit.prevent="loginjwt">

      <a-form-item has-feedback>
        <a-input
          size="large"
          ref="email"
          style="border-radius: 3px !important;"
          placeholder="Email Address"
          v-decorator="[
          'email_address',
          {
            rules: [
              {
                pattern: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                message: 'The input is not valid Email Address!',
              },
              {
                required: true,
                message: 'Please input your Email Address!',
              },
            ],
          },
        ]"
        >
          <a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>

      <a-form-item has-feedback class="mt-5">
        <a-input-password
          size="large"
          v-decorator="['password',{ rules: [{ required: true, message: 'Please input your password!' }] }]"
          style="border-radius: 3px !important;"
          placeholder="Password"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input-password>
      </a-form-item>

      <a-button type="link" @click="forgotPasswordUser" class="p-0 block">Forgot Password ?</a-button>

      <a-button type="primary" size="large" :loading="loading" class="float-right mt-3 w-full" html-type="submit" style="border-radius: 3px !important;">Login</a-button>

    </a-form>

    <vs-divider class="py-5">Or sign in with</vs-divider>

    <div class="social-login-buttons flex justify-center items-center space-x-2">

        <a-button v-google-signin-button="clientId" icon="google" class="border-indigo w-full" style="border-radius: 3px !important;">Google</a-button>
<!--        <a-button icon="facebook" class="border-indigo" style="border-radius: 3px !important;">Facebook</a-button>-->
<!--        <a-button  icon="linkedin" class="border-indigo" style="border-radius: 3px !important;">Linkedin</a-button>-->
        <!--        <button  class="google-signin-button"> Continue with Google</button>-->
        <!--        <div class="g-signin2" data-onsuccess="onSignIn"></div>-->
        <!-- facebook -->
        <!--      <div class="bg-facebook pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithFacebook">-->
        <!--        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-f" class="text-white h-4 w-4 svg-inline&#45;&#45;fa fa-facebook-f fa-w-9" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 512"><path fill="currentColor" d="M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"></path></svg>-->
        <!--      </div>-->

        <!-- TWITTER -->
        <!--      <div class="bg-twitter pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithTwitter">-->
        <!--        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="twitter" class="text-white h-4 w-4 svg-inline&#45;&#45;fa fa-twitter fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path></svg>-->
        <!--      </div>-->

        <!-- GOOGLE -->
        <!--              <div class="bg-google pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithGoogle">-->
        <!--                <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="google" class="text-white h-4 w-4 svg-inline&#45;&#45;fa fa-google fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512"><path fill="currentColor" d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"></path></svg>-->
        <!--              </div>-->

        <!-- GITHUB -->
        <!--      <div class="bg-github pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4" @click="loginWithGithub">-->
        <!--        <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="github-alt" class="text-white h-4 w-4 svg-inline&#45;&#45;fa fa-github-alt fa-w-15" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 512"><path fill="currentColor" d="M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"></path></svg>-->
        <!--      </div>-->
      </div>

    <div class="flex justify-center flex-col md:flex-col">
        <div class="self-center">
          <span>If you dont have account <a-button type="link" @click="registerUser" class="mt-3 font-medium p-0">Sign Up</a-button> for a 14-day free trial.</span>
        </div>
    </div>

  </div>
</template>

<script>

import axios from '@/axios'
import GoogleSignInButton from 'vue-google-signin-button-directive'
import mixins from '../../mixin/mixin'

export default {
  mixins:[mixins],
  components:{
    GoogleSignInButton
  },
  data () {
    return {
      loading: false,
          clientId: '986858475219-461v2efu5b1ghfsofnajak56pt806spa.apps.googleusercontent.com'
    }
  },
  computed: {
    validateForm () {
      return this.form.getFieldValue('email_address') !== '' && this.form.getFieldValue('password') !== ''
    }
  },
  methods: {
    async OnGoogleAuthSuccess (idToken) {
      try{
        this.loading   = true
        const token    = this.$store.state.token_messages
        const { data } = await axios.post('/account/google/oauth2/',{id_token:idToken})
        this.$store.commit('auth/getUserDetail',data.lawyer_user)
        this.$store.commit('auth/getToken',data.token)
        await axios.post('/account/firebase/token/',{web_client_token: token,phone_client_token: token})
        const activeDateAccount = await axios.get('subscription/active-contract')
        localStorage.setItem('expired_account',JSON.stringify(activeDateAccount.data.to_date))
        await this.getPermissions()
        this.$router.push("/dashboard/analytics").then(()=>{});
      }catch (e) {
        this.$message.error('Login google failed')
        throw new Error(e)
      }finally {
        this.loading = false
      }
    },
    OnGoogleAuthFail ({error}) {
      this.$notification['error']({
        message: 'Error',
        description: 'Login google failed',
      });
    },
    loginjwt() {
      this.form.validateFields(async(err,values)=>{
        if(!err){
          try{
            this.loading            = true;
            const token             = this.$store.state.token_messages
            const {data}            = await axios.post('/account/token/',values)
            this.$store.commit('auth/getUserDetail',data.lawyer_user)
            this.$store.commit('auth/getToken',data.token)
            await axios.post('/account/firebase/token/',{web_client_token: token})
            const activeDateAccount = await axios.get('subscription/active-contract')
            localStorage.setItem('expired_account',JSON.stringify(activeDateAccount.data.to_date))
            await this.getPermissions()
            this.$store.dispatch('settings/initConfigurations') // No need to await for this!
            this.$router.push("/dashboard/analytics").then(()=>{});
          }catch (error) {
            this.$notification['error']({
              message: 'Login failed.',
              description: error.data.message || 'Server Error, Try again.'
            });
            throw new Error(error)
          }finally {
            this.loading = false;
          }
        }
      })
    },
    // Google login
    loginWithGoogle () {
      this.$store.dispatch('auth/loginWithGoogle', { notify: this.$vs.notify })
    },
    // Facebook login
    loginWithFacebook () {
      this.$store.dispatch('auth/loginWithFacebook', { notify: this.$vs.notify })
    },
    focusField(){
       this.$refs.email.focus()
    },
    registerUser () {
      this.$router.push('/register')
    },
    forgotPasswordUser(){
      this.$router.push("/forgot-password")
    },
    async codeParamsVerify(){
      try{
        this.$vs.loading()
        const {data} = await axios.post(`/account/verify/${this.$route.params.code}`)
        this.$store.commit('auth/getToken',data.token)
        this.$store.commit('auth/getUserDetail',data.lawyer_user)
        this.$vs.notify({title:'Successful',text:'Account verify Successful',color:'success',position:'top-right',time:5000})
        this.$router.push('/dashboard/analytics',()=>{})
      }catch (e) {
        this.$notification['error']({
          message: 'Error',
          description: e.response.message || 'Server Error, Try again.'
        });
        throw e
      } finally {
        this.$vs.loading.close()
      }
    },
  },

  mounted() {
    if(this.$route.params.code)
      this.codeParamsVerify()
  },
}

</script>


<style lang="scss">
@import "../../style/style.css";
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
}
.border-indigo{
  border-color: #6065cc;
  color: #6065cc;
}
.vs-divider{
  margin: 0 !important;
}
.ant-btn-link{
  color: #6065cc !important;
}
.google-signin-button {
  color: white;
  background-color: red;
  height: 50px;
  font-size: 16px;
  border-radius: 10px;
  padding: 10px 20px 25px 20px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}
</style>
